import * as Yup from 'yup';
import { generateHookValidator } from './yupHook';
import debouncePromise from 'awesome-debounce-promise';
import 'yup-phone';

const phoneSchema = Yup.string()
  .matches(/^\d{10,11}$/)
  .required();
async function isValidPhoneNumber(phoneNumber: string) {
  return await phoneSchema.isValid(phoneNumber);
}

export const debouncePhoneNumber = debouncePromise((value) => isValidPhoneNumber(value), 300);
export const schema = Yup.string()
  .test('is-phoneNumber', '올바른 핸드폰 번호가 아닙니다.', (value) =>
    value ? debouncePhoneNumber(value) : true,
  )
  .nullable();

export const { validate: isPhoneNumber, validateWithHook: isPhoneNumberWithHook } =
  generateHookValidator(schema);
